// src/registered/site-admin/components/Workflow-esg/Workflow_XLS_Support.js
import { GoldenSourceHelper } from "../../../../app/Switch_Core_React_Standards";

/**
 * 🎯 Initial State for an ESG Cycle
 */
export const GetInitialCycleState = () => ({
  validFrom: "",
  validTo: "",
  commentary: "",
  status: 10,
  siteUserGuid: sessionStorage.getItem("SEC_USER_GUID")
});

/**
 * 🎯 Centralized Handshake for the Workflow
 */
export const executeWorkflowHandshake = async (slug, payload,intent = "Download") => {
  const token = sessionStorage.getItem("SEC_SESSION_ID");
  // Standardize to the concise UserRoles pattern
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/${slug}`, {
    method: "POST", // Keeping it consistent with your elegant example
    headers: {
      "Content-Type": "application/json",
      "SITE-KEY": process.env.REACT_APP_SITE_KEY,
      "Authorization": `Bearer ${token}`,
      "X-Intent": intent //
    },
    body: JSON.stringify(GoldenSourceHelper.prepareForApi(payload || {}))
  });
  console.log("Workflow URL", process.env.REACT_APP_API_BASE_URL); // Debug log for payload
  console.log("Workflow Handshake slug:", slug); // Debug log for payload
  console.log("Workflow Intent:", intent); // Debug log for payload


  const result = await response.json();
  return GoldenSourceHelper.normalize(result);
};


/**
 * Validates file extensions against the permitted ESG list
 */
export const IsValidESGFormat = (fileName) => {
  const permitted = ['xlsx', 'xls', 'xbrl', 'xml', 'json', 'csv'];
  const ext = fileName?.split('.').pop().toLowerCase();
  return permitted.includes(ext);
};

/**
 * Formats S3 keys for the Sustina_ESG_Workflow Lambda structure
 */
export const MapFilesToLambdaPayload = (files) => {
  return files.map(f => ({
    key: GoldenSourceHelper.get(f, "prefixedS3Key"),
    type: f.originalFileName?.split('.').pop().toLowerCase()
  }));
};